import type MapFeature from '@/lib/map-feature'
import { featureSelected, featuresInView } from '@/services/map-service'

/**
 * Resolves the currently selected feature to its rendered MapFeature when one
 * is in view. Selection only carries an id/source/layer selector, so the label
 * and presentation data are recovered by matching it against `featuresInView`.
 * Returns `null` when nothing is selected or the selection isn't rendered.
 */
export function getSelectedMapFeature(): MapFeature | null {
  const selected = featureSelected()
  if (!selected) {
    return null
  }
  const selectedId = selected.id
  if (selectedId === undefined || selectedId === null) {
    return null
  }
  const selectedIdString = String(selectedId)
  return (
    Object.values(featuresInView() ?? {})
      .flat()
      .find((feature) => {
        if (feature.source !== selected.source) {
          return false
        }
        if (
          selected.sourceLayer !== undefined &&
          feature.sourceLayer !== selected.sourceLayer
        ) {
          return false
        }
        const featureId = feature.id ?? feature.properties?.id
        return featureId !== undefined && String(featureId) === selectedIdString
      }) ?? null
  )
}
